module.exports = "/_next/static/images/086f930176c09a6c19f138ea53b0ba59-credit-card-hero-lg-1x.jpg";